export default __webpack_public_path__ + "static/media/img6.664e1487.png";